// extracted by mini-css-extract-plugin
module.exports = {"m3DetailsMenuButton":"m3-module--m3DetailsMenuButton--1ZkKn","m3DetailsMenuDialog":"m3-module--m3DetailsMenuDialog--3hFOA"};